export const style = {
  dialogTitle: {
    mt: '15px',
  },
  dialogAction: {
    pr: '25px',
  },
  titleBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  titleVariant: 'h5',
  closeIcon: {
    color: 'action.active',
  },
  errorWrapper: {
    marginTop: '16px',
  },
  contentWraper: {
    marginTop: '16px',
  },
  box: {
    display: 'flex',
    alignItems: 'center',
  },
  typography: {
    opacity: 0.34,
    fontSize: '16px',
    fontWeight: '500',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.5',
    letterSpacing: 'normal',
    color: '#130f35',
  },
  divider: {
    marginTop: '24px',
    marginBottom: '24px',
  },
  dialogContent: {
    height: '300px',
    width: '600px',
  },
} as const;
